<template>

    <div class="address_add">
        <div class="form-outline mb-4 position-relative withIcon">
            <input type="text" v-model="address.address" placeholder="Введите адрес" class="form-control"> 
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.9999 13.4299C13.723 13.4299 15.1199 12.0331 15.1199 10.3099C15.1199 8.58681 13.723 7.18994 11.9999 7.18994C10.2768 7.18994 8.87988 8.58681 8.87988 10.3099C8.87988 12.0331 10.2768 13.4299 11.9999 13.4299Z" stroke="currentColor" stroke-width="1.5"/><path d="M3.61995 8.49C5.58995 -0.169998 18.42 -0.159997 20.38 8.5C21.53 13.58 18.37 17.88 15.6 20.54C13.59 22.48 10.41 22.48 8.38995 20.54C5.62995 17.88 2.46995 13.57 3.61995 8.49Z" stroke="currentColor" stroke-width="1.5"/></svg>
        </div>
        <div class="address_inputs">
            <input type="text" v-model="address.apart" class="form-control" placeholder="Кв/офис"> 
            <input type="text" v-model="address.inter" class="form-control" placeholder="Домофон"> 
            <input type="text" v-model="address.entrance" class="form-control" placeholder="Подъезд"> 
            <input type="text" v-model="address.lvl" class="form-control" placeholder="Этаж"> 
        </div>
        <div class="hcart-order_btn" @click="newAddres()">Сохранить</div>
    </div>
    
    </template>

    <script>
    export default {
       name: 'Address_add',
        data(){
        return {
            address: {
                address: null,
                apart: null,
                inter: null,
                entrance: null,
                lvl: null,
            }
        }
       },
       mounted(){

       },
       methods: {
        newAddres(){
            axios.post(
'/api/user.add.address', {'address' : this.address}
).then( response => {
  if(response.data.status == 'success'){
    this.$bvToast.toast(response.data.message, {
                    title: 'Оповещение',
                    variant: 'success',
                    visible: true
                  }) 
    return this.$emit('updateAddress', null)
   
  }else{
    return this.$bvToast.toast(response.data.message, {
                    title: 'Ошибка',
                    variant: 'danger',
                    visible: true
                  }) 
  }
  
})
        }
       },
       props: ['isMobile'],
       emits: ['updateAddress'],
    }
    </script>
    
    <style scoped>
    
    </style>